export const winTypes = {
  NONE: 0,
  STANDARD: 1,
  BIG: 2,
  MEGA: 3,
  SUPER: 4,
  EPIC: 5,
};
